import type { AxiosResponse } from 'axios';
import { BaseService } from './baseService';
import axiosInstance from '../axiosInstance';

class OrdersService extends BaseService<Order, 'orderID', 'orders'> {
	constructor() {
		super('orderID', 'order', 'orders');
	}

	async purchaseCredits(payload: PurchaseCreditsRequest) {
		const response: AxiosResponse<TavoittajaApiResponse<{ order: Order }>> =
			await axiosInstance.post(`app/orders/purchase`, payload);
		return response.data.data.order;
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new OrdersService();
